import React from "react";
import { Helmet } from "react-helmet-async";

const defaultConfig = {
  title: "AI Fundraising & Advocacy Campaign Tools | ReachThePeople.ai",
  canonical: "https://reachthepeople.ai/",
  description:
    "ReachThePeople.ai offers AI-powered outreach and fundraising tools designed specifically for political and advocacy campaigns. Elevate your campaign communication strategy, leverage cutting-edge political tech, and master digital advocacy with the help of AI",
  keywords:
    "Political campaign tools, Advocacy campaign AI, AI fundraising, AI-powered outreach, Campaign communication tools, Political tech, Digital advocacy, AI campaign strategy",
  robots:
    "index,follow,max-snippet:-1,max-image-preview:large,max-video-preview:-1",
  author: "ReachThePeople.ai Editorial Team",
  publisher: "ReachThePeople.ai",
  contentLanguage: "en",
};

export default function SEO({ pageConfig }) {
  const config = {
    ...defaultConfig,
    ...pageConfig,
  };

  const og = pageConfig?.og ? { ...pageConfig.og } : null;
  const twitter = pageConfig?.twitter ? { ...pageConfig.twitter } : null;

  return (
    <Helmet>
      {config.title && <title>{config.title}</title>}
      {config.description && (
        <meta name="description" content={config.description} />
      )}
      {config.keywords && <meta name="keywords" content={config.keywords} />}
      {config.canonical && <link rel="canonical" href={config.canonical} />}
      {config.robots && <meta name="robots" content={config.robots} />}
      {config.author && <meta name="author" content={config.author} />}
      {config.publisher && <meta name="publisher" content={config.publisher} />}
      {config.contentLanguage && (
        <meta httpEquiv="content-language" content={config.contentLanguage} />
      )}
      {og?.type && <meta property="og:type" content={og.type} />}
      {og?.title && <meta property="og:title" content={og.title} />}
      {og?.description && (
        <meta property="og:description" content={og.description} />
      )}
      {og?.url && <meta property="og:url" content={og.url} />}
      {og?.siteName && <meta property="og:site_name" content={og.siteName} />}
      {twitter?.card && <meta name="twitter:card" content={twitter.card} />}
      {twitter?.title && <meta name="twitter:title" content={twitter.title} />}
      {twitter?.description && (
        <meta name="twitter:description" content={twitter.description} />
      )}
      {pageConfig?.jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(pageConfig.jsonLd)}
        </script>
      )}
    </Helmet>
  );
}
